<script setup>
import { cn } from "@/Utils/cn";

const props = defineProps({
  class: { type: null, required: false },
});
</script>

<template>
  <td :class="cn('p-3 border-b align-middle', props.class)">
    <slot />
  </td>
</template>
